import type {QueryParams} from '@jetbrains/teamcity-ui/dist/utils'

import type {AppThunk} from '../../../../../actions/types'
import type {LoadedEndpoints} from '../../../../../routes/loadEndpoint'
import type {BuildId} from '../../../../../types'
import {preloadBuildArtifactsTree} from '../../../../common/BuildArtifactsTree/BuildArtifactsTree.preload'
import {PipelineRunTabs, pipelineRunTabs} from '../PipelineRunPage.consts'
import {preloadPipelineTab} from '../PipelineTab/PipelineTab.preload'

export const preloadPipelineRunContent =
  (runId: BuildId, queryParams: QueryParams): AppThunk<LoadedEndpoints> =>
  dispatch => {
    const {pipelineRunTab = pipelineRunTabs[0]?.id} = queryParams
    const endpoints: LoadedEndpoints = []
    switch (pipelineRunTab) {
      case PipelineRunTabs.PIPELINE:
        endpoints.push(...dispatch(preloadPipelineTab(runId, queryParams)))
        break
      case PipelineRunTabs.ARTIFACTS:
        endpoints.push(...dispatch(preloadBuildArtifactsTree(runId)))
        break
      default:
    }
    return endpoints
  }
